<template>
  <!-- 添加标签对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="isShowRoleDialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="580px"
    class="crm-add-field-dialog"
  >
    <el-form ref="fieldForm" :model="fieldForm" label-width="80px" :rules="rules">
      <el-form-item label="字段名" prop="name">
        <el-select v-model="fieldForm.name" v-if="action==='add'">
          <el-option
            v-for="item in customizeList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
        <p v-else>{{ fieldForm.name }}</p>
        <el-input v-if="!action==='add'" v-model="fieldForm.name" hidden="true" />
      </el-form-item>
      <el-form-item label="当前状态">
        <el-switch
          v-model="fieldForm.colStatusShow"
          active-text="开"
          inactive-text="关"
          :active-value="1"
          :inactive-value="0"
          :disabled="fieldForm.cannotEdit"
          active-color="#337eff"
          inactive-color="#EAECF0"
        ></el-switch>
      </el-form-item>
      <el-form-item label="应用场景" prop="showSysArr">
        <el-checkbox-group v-model="fieldForm.showSysArr">
          <el-checkbox label="AICC_CRM">客户管理</el-checkbox>
          <el-checkbox label="AICC_WORKBENCH" v-if="fieldForm.showWorkbench" :disabled="fieldForm.disabled">在线坐席</el-checkbox>
          <!-- <el-checkbox label="AICC_ORDER">工单系统</el-checkbox> -->
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="small">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveCustomerCol, updateCustomerCol } from '@/api/crm/clientInfo'

export default {
  props: {
    action: {
      type: String,
      default: '',
      require: true
    },
    customizeList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      fieldForm: { showSysArr: [] },
      isShowRoleDialog: false,
      checkList: [],
      rules: {
        name: [
          { required: true, message: '请选择字段名称', trigger: 'change' }
        ],
        showSysArr: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个应用场景',
            trigger: 'change'
          }
        ]
      },
      mould: 3003
    }
  },
  computed: {
    title() {
      return this.action === 'add' ? '添加新字段' : '编辑新字段'
    }
  },
  methods: {
    handleConfirm() {
      let validFail = false
      this.$refs.fieldForm.validate(valid => {
        validFail = !valid
      })
      if (validFail) {
        return
      }
      // 只能修改可编辑字段的 colStatus
      if (!this.fieldForm.cannotEdit) {
        this.fieldForm.colStatus = this.fieldForm.colStatusShow
      }
      const selectCustomize = this.customizeList.filter(item => {
        if (item.name === this.fieldForm.name) return item
      })
      const options = {
        id: this.fieldForm.id,
        tag: this.fieldForm.tag,
        name: this.fieldForm.name,
        type: this.fieldForm.type,
        colStatus: this.fieldForm.colStatus,
        showSys: this.fieldForm.showSysArr.join(','),
        mould: this.mould
      }
      // 自定义字段添加fieldValues，默认字段的fieldValues定义为blank
      if (selectCustomize && selectCustomize.length > 0) {
        options.tag = selectCustomize[0].tag
        options.type = selectCustomize[0].type
        if (selectCustomize[0].fieldValues) {
          options.fieldValues =
            selectCustomize[0].fieldValues.map(item => item.val).join(',') ||
            'blank'
        } else {
          options.fieldValues = 'blank'
        }
      } else {
        options.fieldValues = 'blank'
      }
      if (options.id) {
        // 编辑自定义字段
        this.$confirm('确定要保存修改内容？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateCustomerCol(options).then(res => {
            if (res.code !== '2000') {
              this.$message.error(res.meaning)
              return
            }
            this.$emit('emitPagination')
            this.handleClose()
          })
        })
      } else {
        // 新增自定义字段
        saveCustomerCol(options).then(res => {
          if (res.code !== '2000') {
            this.$message.error(res.meaning)
            return
          }
          this.$emit('emitPagination')
          this.handleClose()
        })
      }
    },
    handleClose() {
      this.fieldForm = { showSysArr: [] }
      this.isShowRoleDialog = false
      this.$refs.fieldForm.resetFields()
    }
  }
}
</script>

<style  lang="scss">
.crm-add-field-dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-dialog__footer {
    text-align: center;
    padding-top: 15px;
    padding-bottom: 30px;
  }
  .el-form {
    margin: 0px 70px;
    .el-form-item {
      margin-bottom: 15px;
    }
  }
  p {
    font-size: 14px;
    color: #606266;
  }
}
</style>
